enum AutoChartistMessageType {

    TradeNow = "item:trade_now",
}

export {
    AutoChartistMessageType
};
